import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavController,NavParams  } from 'ionic-angular';
import { Usuario } from '../../entities/usuario';
import { DTOAcompanharPix } from '../../dto/dtoAcompanharPix';


@Component({
    selector: 'page-ordem-pagamento',
    templateUrl: 'ordem-pagamento.html'
})
export class OrdemPagamentoPage {
    dataAtual: Date = new Date(); 
    dtAmanha: Date = new Date(); 
    public usuario: Usuario;
    public acompanharPix: DTOAcompanharPix;

    constructor(_formBuilder: FormBuilder     
        ,public navCtrl: NavController,_navParams: NavParams) {        
            this.usuario = _navParams.get('usu');
            this.acompanharPix = _navParams.get('acompanharPix');
            this.dtAmanha.setDate(this.dataAtual.getDate() + 1);
    }

    public fechar(): void {      
        this.navCtrl.pop();
        //if (window) {
        //window.print();
        //} else {
        //console.warn("window object not available for printing.");
       // }
    }
        
}


// WEBPACK FOOTER //
// ./src/pages/ordem-pagamento/ordem-pagamento.ts